import React from 'react'
import { ASTabHeader, PanelCon } from '../styles'
import { SkillsChallenge } from './SkillsChallenge/SkillsChallenge'
import { GameCon } from './AllStarGameCon/GameCon'
import { Voting } from './Voting/Voting'
import { AllStarOuterCon } from '../../AllStarVote/styles'
import { Tab } from '../../../Components/LazyComponents'

export const AllStarContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  // const tabs = ['PLL', 'WLL', 'Skills Competition', 'Voting']
  const tabs = ['PLL', 'WLL', 'Skills Comp',]
  const [value, setValue] = React.useState(0)

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue)
  }

  return (
    <AllStarOuterCon>
      <ASTabHeader
        value={value}
        onChange={handleChange}
        aria-label="asg tabs"
        indicatorColor="primary"
        centered
      >
        {tabs.map((t) => (
          <Tab label={t} key={t} />
        ))}
      </ASTabHeader>
      {tabs.map((t, idx) => (
        <PanelCon key={idx} value={value} index={idx}>
          {t === 'PLL' && <GameCon league="PLL" />}
          {t === 'WLL' && <GameCon league="WLL" />}
          {t === 'Skills Comp' && <SkillsChallenge />}
          {t === 'Voting' && <Voting />}
        </PanelCon>
      ))}
    </AllStarOuterCon>
  )
}
